import { useEffect, useState } from "react";

const KEY = (slug) => `kh-bookmark:${slug}`;

export const loadMark = (slug) => { try { return JSON.parse(localStorage.getItem(KEY(slug)) || "null"); } catch { return null; } };
export const saveMark = (slug, m) => { try { localStorage.setItem(KEY(slug), JSON.stringify({ ...m, at: Date.now() })); } catch { /* storage full or blocked */ } };
export const clearMark = (slug) => { try { localStorage.removeItem(KEY(slug)); } catch { /* blocked */ } };

export const encodeMark = (m) => (m.mode === "pages" ? `p${m.page}` : m.mode === "zoom" ? `z${m.step}` : m.ep ? `e${m.ep}.${m.item || 0}` : `s${m.item || 0}`);
export function decodeMark(code) {
  const m = /^([pzse])(\d+)(?:\.(\d+))?$/.exec(code || "");
  if (!m) return null;
  const n = Number(m[2]);
  return { p: { mode: "pages", page: n }, z: { mode: "zoom", step: n }, s: { mode: "scroll", item: n }, e: { mode: "scroll", ep: n, item: Number(m[3] || 0) } }[m[1]];
}
export const describeMark = (m) => (m.mode === "pages" ? `page ${m.page}` : m.mode === "zoom" ? "your last panel" : m.ep ? `episode ${m.ep}` : "where you stopped scrolling");

export function Countdown({ unlocks, onDone, className = "" }) {
  const target = new Date(`${unlocks}T00:00:00Z`).getTime();
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  const left = Math.max(0, target - now);
  useEffect(() => { if (left === 0) onDone?.(); }, [left, onDone]);
  const s = Math.floor(left / 1000);
  const parts = [[Math.floor(s / 86400), "d"], [Math.floor((s % 86400) / 3600), "h"], [Math.floor((s % 3600) / 60), "m"], [s % 60, "s"]];
  return (
    <span className={`inline-flex gap-2 font-mono ${className}`} data-testid="episode-countdown">
      {left === 0 ? "Unlocked — refresh to read" : parts.map(([v, u]) => <span key={u}><span className="text-2xl text-amber-200">{String(v).padStart(2, "0")}</span><span className="text-xs text-slate-400 ml-0.5">{u}</span></span>)}
    </span>
  );
}
